import Vue from 'vue'
import Vuex from 'vuex'
import menu from '../config/menu'
import studio from '../config/studio'
import firstEditor from '../config/firstEditor'
import secondaryEditor from '../config/secondaryEditor'
import thirdEditor from '../config/thirdEditor'
import reviewExpert from '../config/reviewExpert'


Vue.use(Vuex)
var userinfo = localStorage.getItem('userinfo') || '{}'
userinfo = JSON.parse(userinfo)
const store = new Vuex.Store({
    state: {
        menu: '',
        menuActiveName: '',
        menuOpenNames: [],
        breadcrumb: [],
        userinfo: userinfo,
        isActive: false,
        videourl: '',
        cover: '',
        sourceVideoUrl: '',
        saveId: '',
        material: {},
        emailAddress: '',
        tabname: 'wechat'
    },
    getters: {
        getMaterial: (state) => state.material,
    },
    mutations: {
        tabname(state, tabname) {
            state.tabname = tabname;
        },
        breadcrumb(state, path) {
            var result = []
            recursiveBreadcrumb('path', path, state.menu, 0, result)
            state.breadcrumb = result
        },
        menu(state, route) {
            if (state.userinfo.typeCode) {
                //判断是否为主账号
                state.studioAdmin = userinfo.studioAdmin
                //判断是否为政务号 || 校级高校号
                state.zwhgxh = userinfo.zwhgxh
                state.addschoolFlag = userinfo.addschoolFlag

                var typeCode = state.userinfo.typeCode.toLowerCase();
                if (typeCode == 'studio') { //普通用户
                    state.menu = studio;
                } else if (typeCode == 'admin') { //管理员
                    state.menu = menu;
                } else if (typeCode == 'firsteditor') { //一审
                    state.menu = firstEditor;
                } else if (typeCode == 'secondaryeditor') { //三审
                    state.menu = secondaryEditor;
                }else if (typeCode == 'thirdeditor') { //二审
                    state.menu = thirdEditor;
                }else if (typeCode == 'reviewexpert') { //2022年5月25日18:08:29 新增评审专家
                    state.menu = reviewExpert;
                }

                // 审核中不允许查看数据统计
                if (state.userinfo.typeId==1&&state.userinfo.auditStatus && state.userinfo.auditStatus != "auditpassed") {
                  state.menu = state.menu.filter(val => {
                    return val.name != "数据统计"
                  })
                } else {
                  state.menu = state.menu;
                }

                let activeName = ''
                // let openNames = ["1", "2", "3", "4", "5", "6", "7"]
                let openNames = ['1']
                state.menu.forEach((n, i) => {
                    if (n.path === route.path || (n.match && n.match.indexOf(route.name))) {
                        activeName = i + ''
                    } else if (n.children) {
                        n.children.forEach((m, j) => {
                            if (m.path === route.path || (m.match && m.match.indexOf(route.name) >= 0)) {
                                activeName = i + '-' + j
                                openNames =[]
                                openNames.push(i + '')
                            }
                        })
                    }
                })
                state.menuActiveName = activeName
                state.menuOpenNames = [...openNames]
            }
        },
        set(state, data) {
            Object.assign(state, data)
        },
        setMaterial(state, material) {
            state.material = material;
        }
    },
    actions: {
        setMaterial({ commit }, argu) {
            commit('setMaterial', argu)
        }
    },
    articleBack: true
})

function recursiveBreadcrumb(key, val, data, index, result) {
    for (var i = 0, l = data.length; i < l; i++) {
        var e = data[i]
        if (e[key] && val === e[key]) {
            result[index] = e
            return true
        } else if (e.children) {
            var re = recursiveBreadcrumb(key, val, e.children, index + 1, result)
            if (re) {
                result[index] = e
                return true
            }
        }
    }
    return false
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js